type DebugLogProps = {
  name: string;
  bgColor: string;
  textColor?: string;
  enabled: boolean;
}
const isClient = () => typeof window !== 'undefined' && typeof window.location !== 'undefined';

export const useDebug = ({ name, bgColor, textColor, enabled }: DebugLogProps) => {
  const log = (...args: any) => {
    if (!enabled) return;
    if (!isClient()) return; // Only run in the browser
    // if (!window.location.href.includes('localhost')) return; // Disable logs if not on localhost
    const styles = `background:${bgColor};color:${textColor || 'black'};padding:4px 10px;border-radius:4px;`;
    console.log(`%c${name}`, styles, ...args);
  };
  return { log };
}
